export default __webpack_public_path__ + "static/media/debate_26.4f94bd67.JPG";